import { Text } from "@clipboard-health/ui-components";
import { Link, Stack } from "@mui/material";
import { AppVersionInfo } from "@src/appV2/Accounts/AppVersionInfo/AppVersionInfo";
import { type ReactElement } from "react";

interface AuthFooterProps {
  showAppVersionInfo?: boolean;
}

export function AuthFooter(props: AuthFooterProps = {}): ReactElement {
  const { showAppVersionInfo = false } = props;

  return (
    <Stack spacing={2} alignItems="center" textAlign="center">
      <Text variant="caption">
        <Link
          href="https://clipboardhealth.com/terms-of-service"
          target="_blank"
          sx={{
            color: (theme) => theme.palette.text.secondary,
            "&:hover": {
              color: (theme) => theme.palette.text.primary,
            },
          }}
        >
          Terms of Service
        </Link>{" "}
        and{" "}
        <Link
          href="https://clipboardhealth.com/privacy-policy"
          target="_blank"
          sx={{
            color: (theme) => theme.palette.text.secondary,
            "&:hover": {
              color: (theme) => theme.palette.text.primary,
            },
          }}
        >
          Privacy Policy
        </Link>
      </Text>
      <Text variant="caption">Messaging and data rates may apply</Text>
      {showAppVersionInfo && <AppVersionInfo />}
    </Stack>
  );
}
